export function createOptionsFromTags(tags) {
  return tags.map((tag) => ({ key: tag, text: tag, value: tag }));
}
